import { fetchApi } from '@/services/api-client';

import { SESSIONS_PATH } from './sessions';

export type SessionEnrollment = {
  id: string;
  userId: string;
  fullName: string | null;
  role: string | null;
  gradeLevel: number | null;
};

export const enrollmentsApi = {
  list: (sessionId: string) => fetchApi<SessionEnrollment[]>(`${SESSIONS_PATH}/${sessionId}/enrollments`),

  enroll: (sessionId: string, userId: string) =>
    fetchApi<SessionEnrollment>(`${SESSIONS_PATH}/${sessionId}/enrollments`, {
      method: 'POST',
      body: JSON.stringify({ userId }),
    }),

  unenroll: (sessionId: string, userId: string) =>
    fetchApi(`${SESSIONS_PATH}/${sessionId}/enrollments/${userId}`, { method: 'DELETE' }),
};
